import React, { Component } from "react";
import Zmage from "react-zmage";
import Fade from "react-reveal";
import Slide from "react-reveal";
import '../App.css';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import GridItem from "./Grid/GridItem";
import GridContainer from "./Grid/GridContainer";


const styles = theme => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'hide',
  },
  table: {
    minWidth: 340,
  },
  tableCell: {
    paddingRight: 4,
    paddingLeft: 5,
    fontSize:20,
  }
});


let id = 0;
class Portfolio extends Component {
  render() {
    const { classes } = this.props;
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map(function (projects) {
      let projectImage = "images/portfolio/" + projects.image;

      return (
        <div key={id++} className="columns portfolio-item">
          <div className="item-wrap">
            <Zmage alt={projects.title} src={projectImage} />
            <div style={{ textAlign: "center" }}>{projects.title}</div>
          </div>
        </div>
      );
    });

    const datar = [
      { lecture: "Lecture 1: Introduction to Databases for Big Data", 
      ppt:<a href='https://drive.google.com/file/d/11C6bhzezca5E_rGVjidaXJqoZgbfJzqR/view?usp=sharing' target="_blank" download>pdf</a>
      
      , others: '' },
      { lecture: "Lecture 2: Introduction to Mongo DB and key features", 
      ppt:<a href='https://drive.google.com/file/d/1I5PA4YbZxs3J9r99JFkIk81wjL0-3Q4i/view?usp=sharing' target="_blank" download>pdf</a>
      
      , others: <a href='https://drive.google.com/file/d/1r25Tetyj3Jv9NuKar05DXfxDmj5GD6nU/view?usp=drive_link' target="_blank" download>mongo commands</a> },
      { lecture: "Lecture 3: MongoDb through Javascript shell", 
      ppt:<a href='https://drive.google.com/file/d/1Rm1tpu6hg7xqkL7vWnbQQpZOMBP76tc-/view?usp=sharing' target="_blank" download>pdf</a>
      
      , others: <a href='https://drive.google.com/file/d/1OaK-7i5gdg2LwVmhSCjjOAI1MqrNcwrL/view?usp=sharing' target="_blank" download>Assignment 1</a> },
      { lecture: "", ppt: "", 
        others: <a href='https://drive.google.com/file/d/1aOQx9QjZ5s0-k9qPay1sq5fIOglgpgTp/view?usp=drive_link' target="_blank" download>Assignment 2</a> },
        { lecture: "", ppt: "", 
        others: <a href='https://drive.google.com/file/d/1OsrRazBbsDXuqJaCW4NWPhu30orOwnsP/view?usp=sharing' target="_blank" download>Assignment 3</a> },
        { lecture: "Lecture 4: React, NodeJs, and MongoDb", 
      ppt:<a href='https://drive.google.com/file/d/1cSMDg-YcUukeiX4feE7wVswEHcpJqwKt/view?usp=drive_link' target="_blank" download>ppt</a>
      
      , others: <a href='https://drive.google.com/file/d/1c3MNG3NZ8g1Efgfbe7QpESt2jAMF85Ry/view?usp=sharing' target="_blank" download>Assignment 4</a> },
      { lecture: "Lecture 5: Basic Administration", 
      ppt:<a href='https://drive.google.com/file/d/16wCa_5Wkm2gd_XjL5th-gVEUGUDLdgr2/view?usp=sharing' target="_blank" download>pdf</a> 
      , others: '' }
  ]

  const data = [{
    theory:"",
    theoryAssignment:"",
    lab:<a href='https://drive.google.com/file/d/16I2wI4Jis7k3gZ0GKvQ-7D-ozq1vW2zX/view?usp=sharing' target="_blank" download> Lecture 1</a>,
    labAssignment:<a href='https://drive.google.com/file/d/14guEdjkRtlSrrUqwzjycbWBAYROC2yJ1/view?usp=sharing' target="_blank" download> Assignment 1</a>
  },
  {
    theory:"",
    theoryAssignment:<a href='https://drive.google.com/file/d/1ZaFrdAvlb7w7MPHUsoC3gFxx63yZRyKZ/view?usp=sharing' target="_blank" download> Case Study </a>,
    lab:<a href='https://drive.google.com/file/d/1Qdj-tDc1n4f7Dsko_QPGHhcCMQmoJZOG/view?usp=sharing' target="_blank" download> Lecture 2</a>,
    labAssignment:<a href='https://drive.google.com/file/d/1EFJXylmFkNKcOz_5zSK2V3Gt7GzU5MYp/view?usp=sharing' target="_blank" download> Assignment 2</a>
  },
  {
    theory:"",
    theoryAssignment:<a href='https://drive.google.com/file/d/1wOLAAv_JatBwNJL_giVAFO7CSKj7IHHu/view?usp=sharing' target="_blank" download> Assignment 1 </a>,
    lab:<a href='https://drive.google.com/file/d/1tlgui5ztoLDWi0dQF8TemfBDVngPxOyN/view?usp=sharing' target="_blank" download> Lecture 3</a>,
    labAssignment:<a href='https://drive.google.com/file/d/1epODzmal35ciLYGu1HPccveI4FSuhl22/view?usp=sharing' target="_blank" download> Assignment 3</a>
  },
  {
    theory:"",
    theoryAssignment:<a href='https://drive.google.com/file/d/1qWqVWQk1fpQz6pit3JI3qC-QUmllPsvi/view?usp=sharing' target="_blank" download> Assignment 2 </a>,
    lab:<a href='https://drive.google.com/file/d/1S4LrNhuOkv4q2FEaQUln0qcdsrXqSHk7/view?usp=sharing' target="_blank" download> Lecture 4</a>,
    labAssignment:<a href='https://drive.google.com/file/d/1-E1lFoU9XAggyfBr-GQ1MaX3-zoKZvs7/view?usp=sharing' target="_blank" download> Assignment 4</a>
  },
  {
    theory:<a href='https://drive.google.com/file/d/1I2jl-jgsNig3Uv3OC2bdPvl-d-yxtY6o/view?usp=sharing' target="_blank" download> 1NF/2NF/3NF</a>,
    theoryAssignment:"",
    lab:<a href='https://drive.google.com/file/d/17p-tD4s9IIzNBkxomILLkoSEc7D-VAzO/view?usp=sharing' target="_blank" download> Lecture 5</a>,
    labAssignment:<a href='https://drive.google.com/file/d/1J8M8yNr1zuddClGB3o-J12w070XyBFQ3/view?usp=sharing' target="_blank" download> Assignment 5</a>
  },
  {
    theory:<a href='https://drive.google.com/file/d/1HVjxUQRUvbN_eK2wcQjP668jF-z-WmOm/view?usp=sharing' target="_blank" download> BCNF</a>,
    theoryAssignment:"",
    lab:"",
    labAssignment:<a href='https://drive.google.com/file/d/1xGNswuuJiaudQOBe8aV7wijvi9htvmDL/view?usp=sharing' target="_blank" download> Mini project</a>
  },
  {
    theory:<a href='https://drive.google.com/file/d/1fyNyZaeFIFlerYAYgoqvR1B8AEFWYGB7/view?usp=sharing' target="_blank" download> Multivalued and Higher level FD</a>,
    theoryAssignment:"",
    lab:"",
    labAssignment:""
  },
  {
    theory:<a href='https://drive.google.com/file/d/1LKpa3rti8bEMkfpM8zkpVprwJktFRHGr/view?usp=sharing' target="_blank" download> Formal Query languages</a>,
    theoryAssignment:"",
    lab:"",
    labAssignment:""
  },
  {
    theory:<a href='https://drive.google.com/file/d/14TVH8AjvEu0X87BsxvZQelPfcTe8b30t/view?usp=sharing' target="_blank" download> Transaction management</a>,
    theoryAssignment:"",
    lab:"",
    labAssignment:""
  },
  {
    theory:<a href='https://drive.google.com/file/d/1tVIT26gkFnEU27-e1GSGIUgBTTRp8HcB/view?usp=sharing' target="_blank" download> Concurrency control</a>,
    theoryAssignment:"",
    lab:"",
    labAssignment:""
  }

]


const dataOS = [{
  theory:<a href='https://drive.google.com/file/d/1DPFLtE5SHBdFtdzuLid2mA_Vl46HlTuz/view?usp=sharing' target="_blank" download> Comp Sys Overview</a>,
  theoryAssignment:"",
  lab:<a href='https://drive.google.com/file/d/1nZos9JhAHL51WpFiJuKsEVJ-qUMUcf4z/view?usp=sharing' target="_blank" download> Intro to Unix</a>,
  labAssignment:<a href='https://drive.google.com/file/d/16AVhA4yUzURTWNUhFvdgcnolEuXu743M/view?usp=drive_link' target="_blank" download> Assignment 1</a>
},
{
  theory:<a href='https://drive.google.com/file/d/1DmyKbUO-QWOXvqkh1am_fcnTmNLE7JG9/view?usp=drive_link' target="_blank" download> OS Sys Overview</a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:""
},
{
  theory:<a href='https://drive.google.com/file/d/1PBtjcT3cmzALW432plHfKMAKR3iSmiIa/view?usp=drive_link' target="_blank" download> Process </a>,
  theoryAssignment:"",
  lab:<a href='https://drive.google.com/file/d/1kdq_W07tOfRpWPETVuDOs-n1DsJ40jMh/view?usp=drive_link' target="_blank" download> Shell script</a>,
  labAssignment:<a href='https://drive.google.com/file/d/1Rd9L6bEXzG3ePlv19rlHOrurLS7JesYh/view?usp=sharing' target="_blank" download> Assignment 2</a>
},
{
  theory:<a href='https://drive.google.com/file/d/1syM_lbKhdcfvfKDXzxIcC_R2LYP1txzJ/view?usp=drive_link' target="_blank" download> MultiThreading</a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:""
},
{
  theory:<a href='https://drive.google.com/file/d/1YmukknLlfqkZ_1F7cprJ-rmmbB-SPMfK/view?usp=drive_link' target="_blank" download> CPU Scheduling</a>,
  theoryAssignment:<a href='https://drive.google.com/file/d/1jFDj3ysDo0n3UYjU74Gb8QaUAzCiNpEA/view?usp=sharing' target="_blank" download> Assignment 1</a>,
  lab:"",
  labAssignment:<a href='https://drive.google.com/file/d/14pOi2K8EjUtg74oDLhmpGMOM2tTXFqob/view?usp=drive_link' target="_blank" download> Assignment 3</a>
},
{
  theory:<a href='https://drive.google.com/file/d/1IWcGxhZj_JaKwKUuRJqz3yFprhngGlti/view?usp=drive_link' target="_blank" download> Synchronization</a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:<a href='https://drive.google.com/file/d/1Bc-Av0HVrtzklmpjX2y_wWTKiuJOhPr3/view?usp=drive_link' target="_blank" download> Assignment 4</a>
},
{
  theory:<a href='https://drive.google.com/file/d/1xX3egwrc0dqIdSzJxagTwfEpt8tl6FFv/view?usp=drive_link' target="_blank" download> Deadlock</a>,
  theoryAssignment:<a href='https://drive.google.com/file/d/1aQ5rQtmeKjPLC3RarIiLTKYX2g7BrYwN/view?usp=drive_link' target="_blank" download> Assignment 2</a>,
  lab:"",
  labAssignment:<a href='https://drive.google.com/file/d/1ObNe9kVZeg-MjDlnKIXUjuEuvAbYYXd8/view?usp=drive_link' target="_blank" download> Assignment 5</a>
},
{
  theory:<a href='https://drive.google.com/file/d/1yMOjmtqeTOEZNNLoQj71GxZz8Z9oedqG/view?usp=drive_link' target="_blank" download> Memory Management </a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:""
},
{
  theory:<a href='https://drive.google.com/file/d/1K5KUSXDcZkYCQsLx1n3bDRQB-wIm55f8/view?usp=drive_link' target="_blank" download> Virtual Memory </a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:""
},
{
  theory:<a href='https://drive.google.com/file/d/1QhlaqhgXsm48q-ADaDGBtgyz2aHFoDzL/view?usp=drive_link' target="_blank" download> Disk Management </a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:""
}
]


const basicStat = [{
  theory:<a href='https://drive.google.com/file/d/1k4tmfrtug3GVrth0EATdEIxuNyWS4oxm/view?usp=sharing' target="_blank" download> Sampling and Data</a>,
  theoryAssignment:"",
  lab:"",
  labAssignment:""
}]



    return (
      <section id="courses">
        <Fade left duration={1000} distance="40px">
          <div className="row">
            <div className="twelve columns collapsed">
              <h2>My Courses</h2>

              {/* <div
                id="portfolio-wrapper"
                className="bgrid-quarters s-bgrid-thirds cf"
              >
                {projects}
              </div> */}
              <Slide left duration={1300}>
                I will be taking two courses this semester: Elementary Statistics and Assessment for Mathematics Learning. 
                <div className="row work">
                  <div className="three columns header-col">
                    <h1>
                      <span>Elementary Statistics (SEC8015)</span>
                    </h1>
                  </div>

                  <div className="nine columns main-col">
                  {/* <span> */}
                  {/* Theory Text book <a href="https://drive.google.com/file/d/1HdoBPv9Jciwqv0DGVpwxIeOBUtZPZR1v/view?usp=sharing" target="_blank" download> Download </a>
                  </span>
                  
                  and Lab Text book<a href="https://drive.google.com/file/d/1Bh67c4fTFidHhZJZmvfyvBZkdgxh6YOg/view?usp=sharing" target="_blank" download> Download</a>
                  | Lab submission format <a href="https://docs.google.com/document/d/1RrEknUdiCenkNyWVeyQvqKbHfERtWf38/edit?usp=drive_link&ouid=103607769746570969186&rtpof=true&sd=true" target="_blank" download> Download</a>                     */}

                  
                  <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                  <Paper className={classes.root}>
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.tableCell}>Lecture </TableCell>
                          <TableCell className={classes.tableCell}>Theory Assignment </TableCell>
                          <TableCell className={classes.tableCell}>Lab </TableCell>
                          <TableCell className={classes.tableCell}>Lab Assignment </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {basicStat.map(n => {
                          return (
                            <TableRow key={n.id}>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.theory}
                              </TableCell>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.theoryAssignment}
                              </TableCell>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.lab}
                              </TableCell>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.labAssignment}
                              </TableCell>
                              
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    </Paper>
                    </GridItem>
                    </GridContainer>
                    {/* <span>
                      Project <a href="https://drive.google.com/file/d/1xNA3gzozBnajunooAVGyBm742SPXZQM5/view?usp=sharing" target="_blank" download> Download </a>
                  </span>
                  
                    | Project submission format <a href="https://docs.google.com/document/d/1Hn4M9Zu9LLrpRTwqw_op-x0z87-v-l7V/edit?usp=drive_link&ouid=103607769746570969186&rtpof=true&sd=true" target="_blank" download> Download</a>
                   */}
                  </div>
                </div>

                {/* <div className="row work">
                  <div className="three columns header-col">
                    <h1>
                      <span>Databases for Big Data(CSE4252)</span>
                    </h1>
                  </div>
                  <div className="nine columns main-col">
                    
                  <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                  <Paper className={classes.root}>
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.tableCell}>Lecture </TableCell>
                          <TableCell className={classes.tableCell}>ppt </TableCell>
                          <TableCell className={classes.tableCell}>Others </TableCell>
                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {datar.map(n => {
                          return (
                            <TableRow key={n.id}>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.lecture}
                              </TableCell>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.ppt}
                              </TableCell>
                              <TableCell component="th" scope="row" className={classes.tableCell}>
                                {n.others}
                              </TableCell>
                              
                              
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    </Paper>
                    </GridItem>
                    </GridContainer>
                  </div>
                </div> */}
              </Slide>
            </div>
          </div>
        </Fade>

      </section>
    );
  }
}

export default withStyles(styles)(Portfolio);
